import { queryParamsReducer } from './queryParams';
import { aggregationsReducer } from './aggregations';
import { resultsReducer } from './results';
import { searchMenuReducer } from './searchMenu';
import { aggregationsTreeReducer } from './aggregationsTree';
import { searchReducer } from './search';

export const reducersRaw = {
  queryParams: queryParamsReducer,
  aggregations: aggregationsReducer,
  results: resultsReducer,
  searchMenu: searchMenuReducer,
  aggregationsTree: aggregationsTreeReducer,
  search: searchReducer,
};
